import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import WorkerNavbar from "../../worker-navbar/components";

const ClientHeader = () => {
   return (
      <>

         <header className="header-top position-sticky top-0" style={{ zIndex: "99" }}>
            <div className="tophad bg-primary-heading-main pt-2 pt-lg-3 d-none d-lg-block">
               <div className="container">
                  <div className="row justify-content-end align-items-center">
                     <div className="col-auto">
                        <div className="d-flex">
                           <div className="align-items-center d-flex">
                              <div className="d-flex align-items-center me-4">

                                 <div className="me-0 me-lg-2 "><a href="#" className="text-decoration-none"><img src="/assets/images/header-gmail.svg" alt="..." className="" /></a></div>
                                 <div className=""><a href="#" className="font-size-14 font-weight-semibold line-hight-3 text-white text-decoration-none">Info@ncafoundation.org</a>
                                 </div>
                              </div>
                              {/* <div className="d-flex align-items-center ms-3 me-2  ms-md-4 me-md-3">
                                 <div className="d-flex align-items-center ms-3 me-2  ms-md-4 me-md-3">
                                    <div className="me-0 me-lg-2"><a href="#" className="text-decoration-none"><img src="/assets/images/header-call.svg" alt="..." className="" /></a></div>
                                    <div className=""><a href="#" className="font-size-18 font-weight-semibold line-hight-3 text-white text-decoration-none">(757)937-2020</a>
                                    </div>
                                 </div>
                              </div> */}
                           </div>
                           <div className="mt-1">
                              <a href={`${process.env.REACT_APP_FACEBOOK_URL}`} target="_blank"
                                 rel="noopener noreferrer"><i className="fa fa-facebook me-3 text-white"></i></a>
                              <a href={`${process.env.REACT_APP_INSTAGRAM_URL}`} target="_blank" rel="noopener noreferrer"><i className="fa fa-twitter text-white me-3"></i></a>
                              <a href={`${process.env.REACT_APP_YOUTUBE_URL}`} target="_blank" rel="noopener noreferrer"><i className="fa fa-instagram text-white"></i></a>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>


            <WorkerNavbar />
         </header>

      </>
   );
};

export default ClientHeader;
